import r, { css as n } from "styled-components";
import l from "../Icons/ArrowRight.js";
import o from "../../utils/colors.js";
const p = r.div`
  width: 100%;
`, s = r.div`
  display: flex;
  width: 100%;
`, d = n`
  padding: 24px 16px;
`, t = r.div`
  ${d}
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-bottom: solid 2px transparent;
  background-color: ${o.white};
  transition-property: background-color, border-color;
  transition-duration: 150ms;

  &:hover {
    cursor: pointer;
  }
`, i = r.div`
  padding-left: 10px;
`, $ = r.div`
  padding: 45px 50px 50px;
  color: ${o.blueGrey};
`, g = r(l)`
  width: 15px;
  height: 15px;
  box-sizing: content-box;

  &:before,
  &:after {
    box-sizing: content-box;
  }
`, h = r.button`
  font-family: VIC;
  font-size: 1.185rem;
  font-weight: ${(e) => e.$active ? 700 : 600};
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  flex-grow: 1;
  border-bottom: 2px solid ${(e) => e.$active ? o.white : o.blueGrey10};
  border-right: 2px solid ${o.blueGrey10};
  border-left: none;
  border-top: none;
  padding: 0;
  background-color: ${(e) => e.$active ? o.white : o.blueGrey};

  &:last-child,
  &:last-child:hover {
    border-right: none;
  }

  &:focus {
    outline: none;

    ${t} {
      border-top-color: ${(e) => e.$active ? o.orange : o.blueGrey};
      background-color: ${(e) => e.$active ? o.orange10 : o.blueGrey25};
    }

    ${i} {
      color: ${(e) => e.$active ? o.brown : o.blueGrey};
    }

    div > svg > path {
      fill: ${(e) => e.$active ? o.brown : o.blueGrey};
    }
  }

  ${t} {
    border-top: 6px solid ${(e) => e.$active ? o.orange : "transparent"};
  }

  ${i} {
    color: ${(e) => e.$active ? o.orange : o.blueGrey};
  }

  ${(e) => !e.$active && n`
      &:hover {
        border-right: 2px solid ${o.blueGrey10};
        ${t} {
          background-color: ${o.blueGrey25};
          border-top: 6px solid ${o.blueGrey};
        }

        ${i} {
          color: ${o.blueGrey};
        }
      }
    `};
`;
export {
  g as ArrowIcon,
  $ as Content,
  t as Header,
  h as TabItem,
  s as Tabs,
  i as Title,
  p as Wrapper
};
